import _taggedTemplateLiteral from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import { gql } from '@apollo/client';
import { FILLTER_KEY } from '../apolloStore';
var updateUserAvatar = function updateUserAvatar(_, _ref, _ref2) {
  var id = _ref.id,
    avatar = _ref.avatar;
  var cache = _ref2.cache;
  cache.writeFragment({
    id: cache.identify({
      __typename: "User",
      id: id
    }),
    fragment: gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["fragment UserAvatar on User { avatar }"]))),
    data: {
      avatar: avatar
    }
  });
};
var updateFilterQuery = function updateFilterQuery(_, _ref3, _ref4) {
  var query = _ref3.query;
  var cache = _ref4.cache;
  cache.writeFragment({
    id: cache.identify({
      __typename: "TableFilter"
    }),
    fragment: gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["fragment FilterQuery on TableFilter {\n      filters {\n        query\n      }\n      page\n    }"]))),
    data: {
      filters: {
        q: query
      },
      page: 1
    }
  });
};
var updateFilterSort = function updateFilterSort(_, _ref5, _ref6) {
  var field = _ref5.field,
    asc = _ref5.asc;
  var cache = _ref6.cache;
  cache.writeFragment({
    id: cache.identify({
      __typename: "TableFilter"
    }),
    fragment: gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["fragment FilterSort on TableFilter {\n      filters { \n        sort {\n          field\n          asc\n        }\n      }\n    }"]))),
    data: {
      filters: {
        sort: {
          field: field,
          asc: asc
        }
      }
    }
  });
};
var updateFilterPaging = function updateFilterPaging(_, _ref7, _ref8) {
  var page = _ref7.page,
    first = _ref7.first;
  var cache = _ref8.cache;
  cache.writeFragment({
    id: cache.identify({
      __typename: "TableFilter"
    }),
    fragment: gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["fragment FilterPaging on TableFilter {\n      first\n      page\n    }"]))),
    data: {
      page: page,
      first: first
    }
  });
};
export default {
  updateUserAvatar: updateUserAvatar,
  updateFilterQuery: updateFilterQuery,
  updateFilterSort: updateFilterSort,
  updateFilterPaging: updateFilterPaging
};